import { Navigation } from './components/Navigation';
import { Hero } from './components/Hero';
import { About } from './components/About';
import { Services } from './components/Services';
import { Projects } from './components/Projects';
import { Process } from './components/Process';
import { FAQ } from './components/FAQ';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
import { WebdesignTierdienstleisterPage } from './components/WebdesignTierdienstleisterPage';
import Seo from './components/Seo';

function HomePage() {
    return (
        <>
            <Seo
                title="Johannsen IT Solutions – Webentwicklung & Performance"
                description="Moderne Websites und Web-Apps mit Fokus auf Performance, Design und SEO. Johannsen IT Solutions entwickelt digitale Lösungen, die professionell aussehen und Anfragen bringen."
                keywords={[
                    'Webentwicklung',
                    'Webdesign',
                    'Websites erstellen lassen',
                    'Performance',
                    'SEO',
                    'Johannsen IT Solutions',
                ]}
                canonical="https://johannsen-its.de/"
                image="/og-image.jpg"
                imageAlt="Johannsen IT Solutions – Webentwicklung und Performance"
            />

            <Hero />
            <About />
            <Services />
            <Projects />
            <Process />
            <FAQ />
            <Contact />
        </>
    );
}

function AnimalServicesPage() {
    const origin =
        typeof window !== 'undefined'
            ? window.location.origin
            : 'https://johannsen-its.de';

    const serviceSchema = {
        '@context': 'https://schema.org',
        '@type': 'Service',
        '@id': `${origin}/webdesign-tierdienstleister#service`,
        name: 'Webdesign für Tierdienstleister',
        description:
            'Moderne Websites für Hundefriseure, Hundeschulen, Hundezüchter, Tierpensionen und lokale Tierbetriebe mit Fokus auf Sichtbarkeit, Vertrauen und Kundenanfragen.',
        serviceType: 'Webdesign und Webentwicklung',
        provider: {
            '@id': `${origin}/#business`,
        },
        areaServed: {
            '@type': 'Country',
            name: 'Deutschland',
        },
        audience: {
            '@type': 'Audience',
            audienceType:
                'Tierdienstleister, Hundefriseure, Hundeschulen, Hundezüchter, Tierbetriebe',
        },
        url: `${origin}/webdesign-tierdienstleister`,
    };

    return (
        <>
            <Seo
                title="Webdesign für Tierdienstleister | Websites für Hundefriseure & Hundeschulen"
                description="Webdesign für Tierdienstleister, Hundefriseure, Hundeschulen, Hundezüchter und Tierbetriebe. Moderne Websites, lokale SEO und klare Anfragewege für mehr Sichtbarkeit und Kundenanfragen."
                keywords={[
                    'Webdesign Tierdienstleister',
                    'Website Hundefriseur',
                    'Webdesign Hundeschule',
                    'Website Hundezucht',
                    'Homepage Tierdienstleister',
                    'Webdesign Hundesalon',
                    'lokale SEO Tierdienstleister',
                ]}
                canonical="https://johannsen-its.de/webdesign-tierdienstleister"
                image="/og-image-tierdienstleister.jpg"
                imageAlt="Johannsen IT Solutions – Webdesign für Tierdienstleister"
                schema={[serviceSchema]}
            />

            <WebdesignTierdienstleisterPage />
        </>
    );
}

export default function App() {
    const path = window.location.pathname;

    return (
        <div className="min-h-screen bg-background">
            <Navigation />

            {path === '/webdesign-tierdienstleister' ? (
                <AnimalServicesPage />
            ) : (
                <HomePage />
            )}

            <Footer />
        </div>
    );
}